module.exports = __webpack_public_path__ + "img/huangxiaochen.e0124b36.jpg";